import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const AcceptanceOfTerms = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            By accessing our website, creating an account, or using any of our
            services, you confirm that you are at least 18 years of age (or the
            age of majority in your jurisdiction), you have read, understood,
            and agree to be bound by these Terms and Conditions, and you have
            the legal authority to enter into this agreement on behalf of
            yourself or the organization you represent.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            If you are accessing our services on behalf of a company or other
            legal entity, you represent that you have the authority to bind that
            entity to these Terms. In that case, &quot;you&quot; and
            &quot;your&quot; will refer to that entity. If you do not have such
            authority, you must not accept these Terms or use the services.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            We reserve the right to update or modify these Terms at any time
            without prior notice. Any changes will be posted on this page with
            an updated revision date. Your continued use of the services after
            any such changes constitutes your acceptance of the new Terms. We
            encourage you to review these Terms periodically.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="acceptance">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Acceptance of Terms
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default AcceptanceOfTerms;
